import React, { useEffect, useRef, useState } from 'react'
import {
    AlertType, FormaPagamento, KEY_CODE_ENTER, KEY_CODE_ESCAPE, RelatorioConsultaVendas, classBorderLabelDark, classBt,
    classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasAzul
} from '../../Utils/Types'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { Funcoes } from '../../Utils/Funcoes'
import { FormaPagamentoService } from '../../Pages/FormaPagamento/FormaPagamentoService'
import { VendasService } from '../../Pages/Vendas/vendasService'
import { ModalParcelasCartao, ParcelamentoCartao } from './modal-parcelas'
import { MdPayments } from 'react-icons/md'
import { ModalImpress } from './modal-impress'
import { ReportVendaFinalizadaA4 } from '../../Pages/Vendas/pdf/report-venda-finalizadaA4'
import { ReportVendaFinalizadaBobina } from '../../Pages/Vendas/pdf/report-venda-finalizadaBobina'
import { ModalIdentificarClienteFecharVenda } from './modal-identificar-cliente-fechar-venda'
import { ModalParcelasCrediario, Parcelamento } from './modal-parcelas-crediario'

type Props = {
    visible: boolean
    id_Venda?: number
    valor_venda?: string
    loading?: boolean
    fecharVendaEvent: () => void
    setIdCliente: (idCli: number) => void
    loadingTrue: () => void
    loadingFalse: () => void
    closeModalEvent: () => void
    alterarDescontoModalEvent?: () => void
    dadosVenda?: any[]
    dadosCliente: any
    idCliente: number
    dadosDesconto: any
}

interface TempItem {
    id_Venda: number | undefined,
    idFPag: number,
    valor: string,
    tipo: string
}

export const ModalFecharVenda = React.memo(({ visible, id_Venda, valor_venda, loading, fecharVendaEvent, setIdCliente, loadingTrue, loadingFalse, closeModalEvent, alterarDescontoModalEvent, dadosVenda, dadosCliente, idCliente, dadosDesconto }: Props) => {


    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // -----------------------------------------------
    // ---------- ATRIBUTOS FECHAR VENDA -------------
    // -----------------------------------------------
    const [valorVenda, setValorVenda] = useState(Funcoes.numberFormat(0, 'currency'))
    const [valorLancado, setValorLancado] = useState(Funcoes.numberFormat(0, 'currency'))
    const [valorRestante, setValorRestante] = useState(Funcoes.numberFormat(0, 'currency'))
    const [valorTroco, setValorTroco] = useState(Funcoes.numberFormat(0, 'currency'))
    const [valor, setValor] = useState("")
    //const [valorAcumulado, setValorAcumulado] = useState(0)
    const [idFPag, setIdFPag] = useState(0)
    const [fpagtoCrediario, setFpagtoCrediario] = useState<boolean>(false)
    const [valorCred, setValorCred] = useState("")
    const [observacao, setObservacao] = useState("")

    // -----------------------------------------------
    // ---------- ATRIBUTOS DE CONTROLE DA TELA ------
    // -----------------------------------------------
    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(0)
    const [desabilitar, setDesabilitar] = useState(false)

    // -----------------------------------------------
    // ---------- ATRIBUTOS DE LISTAS ----------------
    // -----------------------------------------------
    const [formaPagamento, setFormaPagamento] = useState<FormaPagamento[]>([])
    const [tempList, setTempList] = useState<any[]>([])
    const [parcelamentoList, setParcelamentoList] = useState<Parcelamento[]>([])
    const [parcelamentoCartaoList, setParcelamentoCartaoList] = useState<ParcelamentoCartao[]>([])

    // -----------------------------------------------
    // -- ATRIBUTOS DE BANDEIRA E NUM. TRANSAÇÃO -----
    // -----------------------------------------------
    const [idBandeiraCartao, setIdBandeiraCartao] = useState<number>(0)
    const [numTransacao, setNumTransacao] = useState("")

    // -----------------------------------------------
    // ---------- ATRIBUTOS DE MODALS ----------------
    // -----------------------------------------------
    const [visibleImpressVenda, setVisibleImpressVenda] = useState(false)
    const [visibleImpressVendaA4, setVisibleImpressVendaA4] = useState(false)
    const [visibleImpressVendaBobina, setVisibleImpressVendaBobina] = useState(false)
    const [visible_Modal_Parcelas, setVisible_Modal_Parcelas] = useState(false)
    const [visible_Modal_Parcelas_Cartao, setVisible_Modal_Parcelas_Cartao] = useState(false)
    const [visibleIdentificarCli, setVisibleIdentificarCli] = useState(false)

    //const [loadingImpressVendaA4, setLoadingImpressVendaA4] = useState(false)
    //const [loadingImpressVendaBobina, setLoadingImpressVendaBobina] = useState(false)
    const [loadingFecharVenda, setLoadingFecharVenda] = useState(false)
    const [loadingIdentifcarCli, setLoadingIdentificarCli] = useState(false)
    //const [loadingImpressVenda, setLoadingImpressVenda] = useState(false)

    const inputRefModal = useRef<any>(null)

    // -----------------------------------------------
    // ---------- ATRIBUTOS DE IMPRESSÃO -------------
    // -----------------------------------------------
    const [dadosParaImpressao, setDadosParaImpressao] = useState<RelatorioConsultaVendas[]>([])
    const [dadosCli, setDadosCli] = useState<any>({})
    //const [descricoesFiltradas, setDescricoesFiltradas] = useState<any[]>([])


    // ------------------------------------------------------------------------- USEEFFECT ----------------------------------------------------------------------
    useEffect(() => {

        for (let i = 0; i < formaPagamento.length; i++) {

            formaPagamento[i].numItem = i
            formaPagamento[i].valor = 0
        }

        if (formaPagamento.length > 0) {
            setIdFPag(formaPagamento[0].id)
        }

    }, [formaPagamento])

    useEffect(() => {
        //console.log("parcelamento ", parcelamentoList)
    }, [parcelamentoList])

    useEffect(() => {

        if (visible) {

            setValorVenda(valor_venda || "0")
            setValorRestante(valor_venda || "0")
            getFormaPagamento()

            let modal = document.getElementById('modal_fechar_venda')
            let modalContent = document.getElementById('modal_content_fechar_venda')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-700px]')
                    modalContent.classList.add('mt-20')
                }
            }

        } else {

            setLinhaSelecionada(0)
            setValorVenda(Funcoes.numberFormat(0, 'currency'))
            setValorLancado(Funcoes.numberFormat(0, 'currency'))
            setValorRestante(Funcoes.numberFormat(0, 'currency'))
            setValorTroco(Funcoes.numberFormat(0, 'currency'))
            setValor("")
            setObservacao("")
            setIdFPag(0)
            setFormaPagamento([])
            setParcelamentoList([])
            setParcelamentoCartaoList([])
            setTempList([])
            setDadosCli([])

            let modal = document.getElementById('modal_fechar_venda')

            if (modal) {
                modal.style.visibility = 'hidden'
                let modalContent = document.getElementById('modal_content_fechar_venda')

                if (modalContent) {
                    modalContent.classList.add('mt-[-700px]')
                    modalContent.classList.remove('mt-20')
                }
            }

        }

    }, [visible])

    const parseValor = (valor: string) => {
        if (valor.includes(",")) {
            return parseFloat(valor.replace("R$", "").replace(/\./g, "").replace(",", "."));
        }
        return parseFloat(valor.replace("R$", "").trim());
    }

    useEffect(() => {

        const parsedValorVenda = parseFloat(valorVenda.replace("R$", '').replace(",", "."))
        const parsedValorRestante = parseFloat(valorRestante.replace("R$", '').replace(",", "."))

        const handleKeyDown = (event: any) => {

            const { key } = event

            if ((key === 'ArrowUp' || key === 'ArrowDown') && visible && !desabilitar && !visible_Modal_Parcelas && !visible_Modal_Parcelas_Cartao && !visibleIdentificarCli) {
                event.preventDefault()

                let nextIndex

                if (key === 'ArrowUp') {
                    nextIndex = linhaSelecionada !== -1 ? linhaSelecionada - 1 : formaPagamento.length

                    if (nextIndex !== -1 && nextIndex < formaPagamento.length) {
                        setIdFPag(formaPagamento[nextIndex].id)
                        setFpagtoCrediario(formaPagamento[nextIndex].crediario === 'S' ? true : false)
                    }

                } else {
                    nextIndex = linhaSelecionada < formaPagamento.length ? linhaSelecionada + 1 : 0

                    if (nextIndex !== -1 && nextIndex < formaPagamento.length) {
                        setIdFPag(formaPagamento[nextIndex].id)
                        setFpagtoCrediario(formaPagamento[nextIndex].crediario === 'S' ? true : false)
                    }

                    //Inputfocus()

                }

                const element = document.getElementById(`produto-fecharVenda-${nextIndex}`);
                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    })
                }

                setLinhaSelecionada(Math.max(0, Math.min(nextIndex, formaPagamento.length - 1)))
                Inputfocus()
            }
        }

        const handleKeyPress = (e: any) => {

            const isEnterKey = e.code === KEY_CODE_ENTER || e.code === "NumpadEnter"
            const isVisible = visible === true
            const parsedValor = parseValor(valor)
            setVisibleMsg(false)

            if (isEnterKey && isVisible && !desabilitar && !visible_Modal_Parcelas && !visible_Modal_Parcelas_Cartao && !visibleIdentificarCli) {

                if (valor === "") {

                    Inputfocus()
                    setValor(valor_venda?.replace("R$", "").replace(/\./g, "").replace(",", ".") || "0")

                } else if (parsedValor === 0 && (formaPagamento[linhaSelecionada].valor || 0) > 0) {

                    getVendaFPagamento(valor)

                    //formaPagamento[linhaSelecionada].tipo === "05" forma de pagamento crediario

                    if (fpagtoCrediario) {
                        setParcelamentoList([])
                        setParcelamentoCartaoList([])
                    }

                } else if (parsedValor === 0) {

                    setValor(valorRestante.replace("R$", "").replace(/\./g, "").replace(",", "."))

                } else if (parsedValor >= 0) {

                    if (formaPagamento[linhaSelecionada].tipo === "05" && tempList.some(item => item && item.tipo === "05" && parseFloat(item.valor) > 0)) {

                        const timer = setTimeout(() => {
                            setVisibleMsg(true)
                            setMessageType("DANGER")
                            setMessage("Valor em crédito ja lançado. Por favor escolha outra forma de pagamento")
                            clearTimeout(timer)
                        }, 0)

                        setValor("0.00")

                    } else {

                        const result = getVendaFPagamento(valor)

                        if (fpagtoCrediario && formaPagamento[linhaSelecionada].tipo === "03" && result) {

                            if (dadosCliente?.id_consumidor > 0 || dadosCli?.id_consumidor > 0 || idCliente > 0) {
                                setVisible_Modal_Parcelas_Cartao(true)
                            } else {
                                setVisibleIdentificarCli(true)
                            }

                            setValorCred((formaPagamento[linhaSelecionada].valor)?.toString() || '0')

                        } else if (fpagtoCrediario && result) {

                            if (dadosCliente?.id_consumidor > 0 || dadosCli?.id_consumidor > 0 || idCliente > 0) {
                                setVisible_Modal_Parcelas(true)
                            } else {
                                setVisibleIdentificarCli(true)
                            }

                            setValorCred((formaPagamento[linhaSelecionada].valor)?.toString() || '0')

                        }

                    }

                }
            }
        }

        const handleMouseUp = (event: any) => {
            if ((event.button === 0 || event.button === 1 || event.button === 2) && visible && !desabilitar && !visible_Modal_Parcelas && !visible_Modal_Parcelas_Cartao && !visibleIdentificarCli) {
                //Inputfocus()
            }
        }

        if (formaPagamento.length > 0) {
            setIdFPag(formaPagamento[linhaSelecionada].id)
            setFpagtoCrediario(formaPagamento[linhaSelecionada].crediario === 'S' ? true : false)
        }

        const handleKeyPressF9 = async (event: any) => {

            if (event.code === "F9" && visible && !desabilitar && !visible_Modal_Parcelas && !visible_Modal_Parcelas_Cartao && !visibleIdentificarCli && parsedValorRestante === parsedValorVenda) {

                setVisibleMsg(false)

                if (loadingTrue) {
                    loadingTrue()
                }

                try {

                    setValor(valor_venda?.replace("R$", "").replace(/\./g, "").replace(",", ".") || "0")

                    setDesabilitar(true)

                    const resp = await VendasService.CadastrarVendaPagamento(id_Venda, idFPag, parseFloat(valor_venda?.replace("R$", "").replace(/\./g, "").replace(",", ".") || "0"), parcelamentoList)

                    if (resp.error) {

                        setDesabilitar(false)

                        setVisibleMsg(true)
                        setMessageType("DANGER")
                        setMessage(resp.msg || "")

                    } else {

                        const newItem: TempItem = { id_Venda, idFPag, valor: parseFloat(valor_venda?.replace("R$", "").replace(/\./g, "").replace(",", ".") || "0").toString(), tipo: formaPagamento[linhaSelecionada].tipo };
                        const updatedTempList = [...tempList]
                        updatedTempList[linhaSelecionada] = newItem
                        setTempList(updatedTempList)

                        /*
                        setVisibleMsg(true)
                        setMessageType("SUCCESS")
                        setMessage("Venda Finalizada com sucesso")
                        */

                        let val = formaPagamento[0].valor = parseFloat(valor_venda?.replace("R$", "").replace(/\./g, "").replace(",", ".") || "0")

                        const valLan = parseFloat(valorLancado.replace("R$", "").replace(/\./g, "").replace(",", ".")) + parseFloat(val.toString())
                        setValorLancado(Funcoes.numberFormat(valLan, 'currency'))

                        setValorRestante(Funcoes.numberFormat(0, 'currency'))

                        setValor(Funcoes.numberFormat(0, 'currency'))


                        const relatorio = {
                            id_venda: id_Venda,
                        }

                        const respDadosVenda = await VendasService.ConsultarVendas(relatorio)

                        if (respDadosVenda.data.length > 0) {


                            setDadosParaImpressao(respDadosVenda.data)
                            setVisibleImpressVenda(true)

                        } else {

                            if (fecharVendaEvent) {
                                fecharVendaEvent()
                            }
                        }

                        //const resp = await VendasService.ImprimirVenda("192.168.1.76", "9100", id_Venda, "//Rondinely/MP-4200")
                        //setDesabilitar(false)

                    }

                } catch (error) {

                    setDesabilitar(false)

                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Ocorreu um erro ao finalizar a venda pelo atalho")

                } finally {

                    if (loadingFalse) {
                        loadingFalse()
                    }
                }

            }
        }

        const handleKeyPressESC = (event: any) => {

            if (event.code === KEY_CODE_ESCAPE && visible && !desabilitar && !visible_Modal_Parcelas && !visible_Modal_Parcelas_Cartao && !visibleIdentificarCli) {

                if (closeModalEvent) {
                    closeModalEvent()
                }

                setVisibleMsg(false)
                setFpagtoCrediario(false)
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('keydown', handleKeyPress)
        document.addEventListener('keydown', handleKeyPressF9)
        document.addEventListener('keydown', handleKeyPressESC)
        document.addEventListener('mouseup', handleMouseUp)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('keydown', handleKeyPress)
            document.removeEventListener('keydown', handleKeyPressF9)
            document.removeEventListener('keydown', handleKeyPressESC)
            document.removeEventListener('mouseup', handleMouseUp)
        }

    }, [linhaSelecionada, formaPagamento, valor, valorTroco, visible, visibleIdentificarCli, tempList, valorRestante, desabilitar, idFPag, visible_Modal_Parcelas, visible_Modal_Parcelas_Cartao, fpagtoCrediario])


    // ------------------------------------------------------------------------- FUNÇÕES DA API ----------------------------------------------------------------------
    const getFormaPagamento = async () => {
        setLoadingFecharVenda(true)

        try {

             const relatorio = {
                field: '',
                filter_type: '',
                filter: ''
            }

            const resp = await FormaPagamentoService.Filter(relatorio)
            setFormaPagamento(resp.data)

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro ao buscar as formas de pagamento")

        } finally {
            setLoadingFecharVenda(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const getVendaFPagamento = (vl: any) => {

        const parsedValorVenda = parseFloat(valorVenda.replace("R$", "").replace(/\./g, "").replace(",", "."))
        const parsedValorRestante = parseFloat(valorRestante.replace("R$", "").replace(/\./g, "").replace(",", "."))
        const parsedValorLancado = parseFloat(valorLancado.replace("R$", "").replace(/\./g, "").replace(",", "."))

        setVisibleMsg(false)

        if (formaPagamento[linhaSelecionada].tipo != '01' && (vl > parsedValorVenda || vl > parsedValorRestante)) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Apenas pagamentos em dinheiro podem exceder o valor da venda")
            return false

        } else {

            // Verifique se linhaSelecionada é um índice válido
            if (linhaSelecionada >= 0 && linhaSelecionada < formaPagamento.length) {

                const currentFormaPagamento = formaPagamento[linhaSelecionada]
                const currentTempList = tempList[linhaSelecionada]

                // Verifique se tempList tem um item para linhaSelecionada
                if (currentTempList && currentFormaPagamento.id === currentTempList.idFPag) {

                    tempList[linhaSelecionada].valor = valor
                    formaPagamento[linhaSelecionada].valor = vl

                    let vlLancado = 0

                    for (let i = 0; i < tempList.length; i++) {
                        if (tempList[i]) { // Verifique se tempList[i] não é undefined
                            vlLancado += parseFloat(tempList[i].valor)
                        }
                    }

                    setValorLancado(Funcoes.numberFormat(vlLancado || 0, 'currency'))

                    let vlRest = parsedValorVenda - vlLancado
                    if (vlRest < 0) {
                        setValorRestante(Funcoes.numberFormat(0, 'currency'))
                    } else {
                        setValorRestante(Funcoes.numberFormat(vlRest, 'currency'))
                    }

                    const valTroco = vlLancado - parsedValorVenda
                    if (valTroco < 0) {
                        setValorTroco(Funcoes.numberFormat(0, 'currency'))
                    } else {
                        setValorTroco(Funcoes.numberFormat(valTroco, 'currency'))
                    }

                    //setValorAcumulado(valorAcumulado + vl)

                } else {

                    const newItem: TempItem = { id_Venda, idFPag: currentFormaPagamento.id, valor, tipo: formaPagamento[linhaSelecionada].tipo }
                    const updatedTempList = [...tempList]
                    updatedTempList[linhaSelecionada] = newItem
                    setTempList(updatedTempList)

                    let val = formaPagamento[linhaSelecionada].valor = vl

                    const valLan = parsedValorLancado + parseFloat(val.toString())
                    setValorLancado(Funcoes.numberFormat(valLan, 'currency'))

                    const valRest = parsedValorRestante - parseFloat(val.toString())

                    if (valRest < 0) {
                        setValorRestante(Funcoes.numberFormat(0, 'currency'))
                    } else {
                        setValorRestante(Funcoes.numberFormat(valRest, 'currency'))
                    }

                    if (parseFloat(val.toString()) > parsedValorRestante) {
                        const valTroco = (parsedValorLancado + parseFloat(val.toString())) - parsedValorVenda
                        setValorTroco(Funcoes.numberFormat(valTroco, 'currency'))
                    }

                    //setValorAcumulado(valorAcumulado + vl)
                }
            }

            setValor("0.00")
            return true


        }
    }

    const finalizarVenda = async () => {

        if (loadingTrue) {
            loadingTrue()
        }

        setVisibleMsg(false)

        try {

            setDesabilitar(true)

            const pagamentos = tempList

            const resp = await VendasService.FinalizaVenda(id_Venda || 0, parcelamentoList, parcelamentoCartaoList, idBandeiraCartao, numTransacao, pagamentos, parseFloat(valorTroco.replace("R$", "").replace(",", ".")), observacao)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                /*
                for (let i = 0; i < tempList.length; i++) {
                    if (tempList[i] && tempList[i].valor > 0) {
                        await VendasService.CadastrarVendaPagamento(tempList[i].id_Venda, tempList[i].idFPag, tempList[i].valor, parcelamentoList);
                    }
                }
                */
                //const resp = await VendasService.ImprimirVenda(localStorage.getItem("@ecommerce/ip") || "", localStorage.getItem("@ecommerce/porta") || "", id_Venda, localStorage.getItem("@ecommerce/path_impressora") || "")

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage("Venda finalizada com sucesso")

                const relatorio = {
                    id_venda: id_Venda,
                }

                const respDadosVenda = await VendasService.ConsultarVendas(relatorio)

                if (respDadosVenda.data.length > 0) {
                    setDadosParaImpressao(respDadosVenda.data)
                    setVisibleImpressVenda(true)

                } else {

                    if (fecharVendaEvent) {
                        fecharVendaEvent()
                    }
                }
            }



        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro ao finalizar a venda")

        } finally {

            setDesabilitar(false)

            if (loadingFalse) {
                loadingFalse()
            }
        }
    }

    const identificarConsumidor = async (dadosConsumidor: any) => {

        setVisibleMsg(false)
        setLoadingIdentificarCli(true)

        try {

            /*
           let newCli = null
    
           if (dadosConsumidor.id_consumidor <= 0) {
    
               let newCliente: any = {
                   nome: dadosConsumidor.nome_consumidor,
                   endereco: dadosConsumidor.logradouro,
                   bairro: dadosConsumidor.bairro,
                   numero: dadosConsumidor.numero,
                   cep: dadosConsumidor.cep,
                   id_cidade: dadosConsumidor.id_cidade,
                   uf: dadosConsumidor.uf,
                   tipo_pessoa: dadosConsumidor.doc.length === 14 ? "J" : "F",
                   cnpj_cpf: dadosConsumidor.doc,
                   ie_rg: "isento",
                   complemento: "",
                   observacao: dadosConsumidor.observacao,
                   ativo: "S"
               }
    
               newCli = await ClientesService.Save(newCliente)
           }
           */

            let itens: any = {
                id_venda: id_Venda,
                id_consumidor: dadosConsumidor.id_consumidor,
                nome_consumidor: dadosConsumidor.nome_consumidor,
                doc: dadosConsumidor.doc,
                logradouro: dadosConsumidor.logradouro,
                bairro: dadosConsumidor.bairro,
                numero: dadosConsumidor.numero,
                complemento: dadosConsumidor.complemento,
                uf: dadosConsumidor.uf,
                id_cidade: dadosConsumidor.id_cidade,
                observacao: dadosConsumidor.observacao,
                cep: dadosConsumidor.cep,
                idVendedor: dadosConsumidor.idVendedor,
                nomeVendedor: dadosConsumidor.nomeVendedor
            }

            setDadosCli(itens)
            setIdCliente(itens.id_consumidor || 0)

            //setIdCli(newCli ? newCli.id : dadosConsumidor.id_consumidor)

            const resp = await VendasService.IdentificarConsumidorVenda(itens)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage("Identificação realizada com sucesso")

                setVisibleIdentificarCli(false)

                if (formaPagamento[linhaSelecionada].tipo === "03") {

                    setVisible_Modal_Parcelas_Cartao(true)
                } else {
                    setVisible_Modal_Parcelas(true)
                }


            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro na identificação do consumidor")
            setDadosCli("")

        } finally {
            setLoadingIdentificarCli(false)
        }

    }


    // ------------------------------------------------------------------------- FUNÇÕES DE MODAL ----------------------------------------------------------------------
    const fecharModalParcelas = () => {
        setVisible_Modal_Parcelas(false)
        setVisible_Modal_Parcelas_Cartao(false)
        Inputfocus()
    }

    const fecharModalParcelasEsc = () => {

        setVisible_Modal_Parcelas(false)
        setVisible_Modal_Parcelas_Cartao(false)
        Inputfocus()

        setIdFPag(0)
        setFormaPagamento([])
        setTempList([])
        setLinhaSelecionada(0)
        setValorVenda(Funcoes.numberFormat(0, 'currency'))
        setValorLancado(Funcoes.numberFormat(0, 'currency'))
        setValorRestante(Funcoes.numberFormat(0, 'currency'))
        setValorTroco(Funcoes.numberFormat(0, 'currency'))

        setValorVenda(valor_venda || "0")
        setValorRestante(valor_venda || "0")
        getFormaPagamento()

    }

    const fecharModalVendaFinalizadaA4 = () => {
        setVisibleImpressVendaA4(false)
        fecharModalImpress()
    }

    const fecharModalVendaFinalizadaBobina = () => {
        setVisibleImpressVendaBobina(false)
        fecharModalImpress()
    }

    const fecharModalImpress = () => {
        setVisibleImpressVenda(false)

        const timer = setTimeout(() => {

            setParcelamentoList([])
            setParcelamentoCartaoList([])

            if (fecharVendaEvent) {
                fecharVendaEvent()
            }

            setLinhaSelecionada(0)
            setValorVenda(Funcoes.numberFormat(0, 'currency'))
            setValorLancado(Funcoes.numberFormat(0, 'currency'))
            setValorRestante(Funcoes.numberFormat(0, 'currency'))

            setValor("")
            setObservacao("")
            //setIdVenda(0)
            setIdFPag(0)
            setFormaPagamento([])
            setTempList([])
            getFormaPagamento()
            setFpagtoCrediario(false)

            //setLoadingImpressVenda(false)

            setDesabilitar(false)
            clearTimeout(timer)

        }, 150)

    }

    const fecharModalIdentificacaoCliente = () => {
        setVisibleIdentificarCli(false)
        setVisibleMsg(false)

        setIdFPag(0)
        setFormaPagamento([])
        setTempList([])
        setLinhaSelecionada(0)
        setValorVenda(Funcoes.numberFormat(0, 'currency'))
        setValorLancado(Funcoes.numberFormat(0, 'currency'))
        setValorRestante(Funcoes.numberFormat(0, 'currency'))

        setValorVenda(valor_venda || "0")
        setValorRestante(valor_venda || "0")
        getFormaPagamento()
    }


    // ------------------------------------------------------------------------- FUNÇÕES DE STATE ATRIBUTOS ----------------------------------------------------------------------
    const valorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeParcelamentoList = (parcelamento: Parcelamento[]) => {
        setParcelamentoList(parcelamento)
    }

    const handleChangeParcelamentoCartaoList = (parcelamento: ParcelamentoCartao[]) => {
        setParcelamentoCartaoList(parcelamento)
    }

    const handleChangeIdBandeiraCartao = (idBandeira: number) => {
        setIdBandeiraCartao(idBandeira)
    }

    const handleChangeNumTransacao = (numTransacao: string) => {
        setNumTransacao(numTransacao)
    }

    // ------------------------------------------------------------------------- FUNÇÕES DE STATE ATRIBUTOS ----------------------------------------------------------------------
    const observacaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setObservacao(e.target.value)
    }

    // ------------------------------------------------------------------------- FUNÇÕES DE FOCUS E ORDENAÇÃO ----------------------------------------------------------------------
    const handleClick = (item: any, id: any) => {
        setLinhaSelecionada(item.numItem === linhaSelecionada ? 0 : item.numItem)
        setIdFPag(item.id)
        setFpagtoCrediario(item.crediario)
    }

    const ordenarPorCrescente = (a: any, b: any) => {
        return a.tipo - b.tipo
    }

    formaPagamento.sort(ordenarPorCrescente)

    const Inputfocus = () => {
        inputRefModal.current?.focus()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }


    // ------------------------------------------------------------------------- FUNÇÕES DE IMPRESSÃO ----------------------------------------------------------------------
    const imprimirVendaA4 = () => {

        //setLoadingImpressVendaA4(true)

        /*
        // Filtra os pagamentos que são válidos e depois mapeia o idFPag
        const idsPagamento = tempList
            .filter(pagamento => pagamento && pagamento.idFPag && parseFloat(pagamento.valor) > 0) // Verifica se pagamento não é undefined ou null
            .map(pagamento => pagamento.idFPag);

        const descFiltradas = formaPagamento
            .filter(forma => forma && idsPagamento.includes(forma.id)) // Verifica se 'forma' não é undefined ou null
            .map(forma => ({
                descricao: forma.descricao, // Pega a descrição
                valor: forma.valor // Pega o valor
            }));

        setDescricoesFiltradas(descFiltradas)
        */

        setVisibleImpressVendaA4(true)

        //setLoadingImpressVendaA4(false)


        //const pdf = new ReportVendaFinalizadaPDF()
        //pdf.GerarPDF(dadosVenda, dadosCliente, descricoesFiltradas, parcelamentoList, dadosDesconto)

        //fecharModalImpress()

    }

    const imprimirVendaBobina = () => {

        //setLoadingImpressVendaBobina(true)

        //setVisibleImpressVenda(false)

        /*
        // Filtra os pagamentos que são válidos e depois mapeia o idFPag
        const idsPagamento = tempList
            .filter(pagamento => pagamento && pagamento.idFPag && parseFloat(pagamento.valor) > 0) // Verifica se pagamento não é undefined ou null
            .map(pagamento => pagamento.idFPag);

        const descFiltradas = formaPagamento
            .filter(forma => forma && idsPagamento.includes(forma.id)) // Verifica se 'forma' não é undefined ou null
            .map(forma => ({
                descricao: forma.descricao, // Pega a descrição
                valor: forma.valor // Pega o valor
            }));

        setDescricoesFiltradas(descFiltradas) 
        */

        setVisibleImpressVendaBobina(true)

        //setLoadingImpressVendaBobina(false)

        //window.open('http://localhost:3000/venda/', 'teste', 'width: 100, heigth: 100')

    }


    return (

        <div id="modal_fechar_venda" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 overflow-auto`}>

            <div id="modal_content_fechar_venda" className={`relative flex flex-col w-[90%] xl:w-[70%] h-[660px] bg-white dark:bg-slate-600 rounded-lg mt-[-700px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                {/* Header */}
                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <MdPayments size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-100`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-white flex items-center font-semibold`}>Pagamento</span>
                </div>
                {/* Header */}

                {/* Body */}
                <div className={`absolute top-[70px] flex flex-row w-full`}>

                    <div className={`w-[70%] h-full cursor-default p-1 `}>

                        {loadingFecharVenda &&

                            <div className={`h-[360px] flex justify-center items-center`}>
                                <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                </div>

                            </div>
                        }
                        {!loadingFecharVenda &&
                            <>

                                <div className={`w-full ${formaPagamento.length > 7 ? `pr-[11px]` : ``} `}>

                                    <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                        <li className={`h-full border-2 border-white dark:border-slate-600`}>

                                            <div className={`w-full flex flex-row h-10 font-mono`}>

                                                <div className={`flex items-center w-[80%] h-full border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Descrição</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[20%] h-full border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Valor</span>
                                                </div>

                                            </div>

                                        </li>

                                    </ul>

                                </div>

                                <div className={`h-[320px] overflow-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin`}>

                                    <div className={`w-full h-auto text-black dark:text-slate-200`}>

                                        <ul className={`w-full`}>

                                            {formaPagamento.length > 0 &&
                                                formaPagamento.map((item, index) => {
                                                    return (

                                                        <li key={item.id} tabIndex={0} onClick={() => handleClick(item, item.numItem)} id={`produto-fecharVenda-${index}`} className={`w-full h-auto duration-150 transition-all focus:outline-none border-2 ${index === linhaSelecionada ? 'border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'}  hover:bg-slate-200 dark:hover:bg-slate-500 cursor-pointer`}>

                                                            <div className={`w-full flex flex-row h-[42px] font-mono`}>

                                                                <div className={`flex items-center w-[80%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{item.descricao}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[20%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-2`}>{Funcoes.numberFormat(parseFloat(item.valor?.toString() || "0"), 'currency')}</span>
                                                                </div>

                                                            </div>

                                                        </li>
                                                    )
                                                })
                                            }

                                        </ul>

                                    </div>

                                </div>

                            </>

                        }

                    </div>

                    <div className={`w-[30%] h-full mt-2`}>

                        <div className={`relative p-2`}>
                            <input id="valorVendaModal" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' value={valorVenda} autoComplete="off" disabled={true} />
                            <label htmlFor="valorVendaModal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Valor da Venda</label>
                        </div>

                        <div className={`relative p-2`}>
                            <input id="valorLancadoModal" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' value={valorLancado} autoComplete="off" disabled={true} />
                            <label htmlFor="valorLancadoModal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Valor Lançado</label>
                        </div>

                        <div className={`relative p-2`}>
                            <input id="valorRestanteModal" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' value={valorRestante} autoComplete="off" disabled={true} />
                            <label htmlFor="valorRestanteModal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Valor Restante</label>
                        </div>

                        <div className={`relative p-2`}>
                            <input ref={inputRefModal} id="valorModal" className={`${classInput} ${classInputDark}`} type="text" placeholder=' ' value={valor} onChange={valorChange} autoComplete="off" />
                            <label htmlFor="valorModal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Valor</label>
                        </div>

                        <div className={`relative p-2`}>
                            <input id="descontoModal" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' value={dadosDesconto} disabled={true} autoComplete="off" />
                            <label htmlFor="descontoModal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Desconto</label>
                        </div>

                        <div className={`relative p-2`}>
                            <input id="trocoModal" className={`${classInput} ${classInputDark} h-[60px] text-2xl font-bold cursor-not-allowed`} type="text" placeholder=' ' value={valorTroco} disabled={true} autoComplete="off" />
                            <label htmlFor="trocoModal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Troco</label>
                        </div>

                        <div className={`relative p-2`}>
                            <input id="obsFinalizarVenda" className={`${classInput} ${classInputDark} h-[60px]`} type="text" placeholder=' ' value={observacao} autoComplete="off" onChange={observacaoChange} />
                            <label htmlFor="obsFinalizarVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Observação</label>
                        </div>

                        <div className={`relative p-2`}>
                            <button className={`${classbtColunasAzul}`} onClick={alterarDescontoModalEvent}>
                                Alterar Desconto
                            </button>
                        </div>

                    </div>

                </div>
                {/* Body */}

                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-start bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-2 rounded-b-lg space-x-3`}>

                    <div className={`w-[85%] flex items-center justify-start`}>

                        <div className={`w-auto text-[15px] mx-1 dark:text-white`}>

                            <span className={`mx-2 font-semibold`}>
                                ( F9 )
                            </span>

                            <span className={`opacity-60`}>
                                Fechar a venda com dinheiro
                            </span>

                        </div>

                        <div className={`w-auto text-[15px] mx-1 dark:text-white`}>

                            <span className={`mx-2 font-semibold`}>
                                ( ENTER )
                            </span>
                            <span className={`opacity-60`}>
                                Lançar o valor
                            </span>

                        </div>

                        <div className={`w-auto text-[15px] mx-1 dark:text-white`}>

                            <span className={`mx-2 font-semibold`}>
                                ( ESC )
                            </span>
                            <span className={`opacity-60`}>
                                Voltar
                            </span>

                        </div>

                    </div>

                    <div className={`w-[15%]`}>
                        <div className={`w-full flex justify-end`}>
                            <button onClick={finalizarVenda} className={`${classbtAzul} ${classBt} mx-1 disabled:opacity-50 disabled:hover:bg-[#3498db] disabled:cursor-not-allowed`} disabled={parseFloat(valorRestante.replace("R$", "").replace(/\./g, "").replace(",", ".")) > 0} >
                                {loading &&
                                    <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                    </div>
                                }
                                {!loading ? `FINALIZAR` : `AGUARDE`}

                            </button>
                        </div>
                    </div>

                    {/*
                    <button
                        onClick={closeModalEvent} disabled={loading}
                        className={`${classBt} text-black dark:text-slate-100 ring-1 ring-inset ring-slate-300 hover:ring-black dark:ring-slate-400 dark:hover:bg-slate-500 mx-3`}>
                        CANCELAR
                    </button>
                    */}

                </div>
                {/* Footer */}

            </div>

            <ModalImpress
                titulo="Imprimir venda"
                msg="Escolha o método de impressão"
                visible={visibleImpressVenda}
                buttonConfirmClickA4={imprimirVendaA4}
                buttonConfirmClickBOBINA={imprimirVendaBobina}
                closeModalEvent={fecharModalImpress}

            />

            <ReportVendaFinalizadaA4
                visible={visibleImpressVendaA4}
                dadosReimpressao={dadosParaImpressao}
                closeModalEvent={fecharModalVendaFinalizadaA4}
            />

            <ReportVendaFinalizadaBobina
                visible={visibleImpressVendaBobina}
                dadosReimpressao={dadosParaImpressao}
                closeModalEvent={fecharModalVendaFinalizadaBobina}
                reciboReimprimido={false}
            />

            <ModalParcelasCrediario
                visible={visible_Modal_Parcelas}
                valor_venda_crediario={valorCred}
                parcelamento={parcelamentoList}
                setParcelamento={handleChangeParcelamentoList}
                onClose={fecharModalParcelas}
                onCloseEsc={fecharModalParcelasEsc}
            />

            <ModalParcelasCartao
                visible={visible_Modal_Parcelas_Cartao}
                valor_venda_cartao={valorCred}
                parcelamentoCartao={parcelamentoList}
                setParcelamentoCartao={handleChangeParcelamentoCartaoList}
                setIdBandeiraCartao={handleChangeIdBandeiraCartao}
                setNumTransacaoCartao={handleChangeNumTransacao}
                onCloseCartao={fecharModalParcelas}
                onCloseEscCartao={fecharModalParcelasEsc}
            />

            <ModalIdentificarClienteFecharVenda
                visible={visibleIdentificarCli}
                loading={loadingIdentifcarCli}
                idVenda={id_Venda?.toString() || '0'}
                identificarConsumidorEvent={identificarConsumidor}
                closeModalEvent={fecharModalIdentificacaoCliente}
            />

        </div>
    )
})